<template>
  <div class="Appdownload">
    <div class="bigImg">
      <div class="top-left">
        <img class="top-img" src="../../static/index/top-app.png" alt="" />
        <div class="top-title">世界 一手掌握</div>
        <div class="top-titles">一机在手，指尖盈利</div>
        <img class="top-imgs" @click="scrollToTarget" src="../../static/index/top-download.png" alt="" />
        <div class="top-flex">
          <div class="top-bottoms">
            <img src="../../static/index/smartphone-device.png" alt="" />
            <div>
              <span>支持多平台</span>
              <span>双端互通</span>
            </div>
          </div>
          <div class="top-line"></div>
          <div class="top-bottoms">
            <img src="../../static/index/verified-user.png" alt="" />
            <div>
              <span>简单</span>
              <span>易用</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="iconBox">
      <div class="title">
        <span>即刻下载</span> 掌控您的财富先机
      </div>
      <div class="titles">
        智赢未来，开启财富增长新篇章，指尖轻触，商机尽在掌握
      </div>
      <div class="ibsBox">
        <img src="../../static/appDownload/card.png" alt="">
        <img class="phone" src="../../static/appDownload/phone.png" alt="">
        <img class="phone1" src="../../static/appDownload/phone1.png" alt="">
        <div class="icon1">
          <img class="icon-img" src="../../static/appDownload/icon1.png" alt="">
          <img class="icon-imgs" src="../../static/appDownload/text3.png" alt="">
        </div>
        <div class="icon2">
          <img class="icon-img" src="../../static/appDownload/icon2.png" alt="">
          <img class="icon-imgs" src="../../static/appDownload/text5.png" alt="">
        </div>
        <div class="icon3">
          <img class="icon-img" src="../../static/appDownload/icon3.png" alt="">
          <img class="icon-imgs" src="../../static/appDownload/text4.png" alt="">
        </div>
        <div class="icon4">
          <img class="icon-img" src="../../static/appDownload/icon4.png" alt="">
          <img class="icon-imgs" src="../../static/appDownload/text7.png" alt="">
        </div>
        <div class="icon5">
          <img class="icon-img" src="../../static/appDownload/icon5.png" alt="">
          <img class="icon-imgs" src="../../static/appDownload/text2.png" alt="">
        </div>
        <div class="icon6">
          <img class="icon-img" src="../../static/appDownload/icon6.png" alt="">
          <img class="icon-imgs" src="../../static/appDownload/text1.png" alt="">
        </div>
      </div>
    </div>
    <div class="part2" ref="targetElement">
      <div class="part2-left" >
        <img v-if="showAndroid" @click="iosDownload" src="../../static/appDownload/ios.png" class="download" alt="" />
        <img v-if="showAndroid" @click="androidDownload" src="../../static/appDownload/Android.png" class="download ios" alt="" />
        <div v-if="showAndroid">扫码下载</div>
        <div v-if="showAndroid" style="margin: 0 0 10px 0;">{{appName}}APP</div>
        <div v-if="showAndroid" class="codeBox">
        <canvas v-if="showAndroid"  class="canvasCode" ref="qrcodeCanvas"></canvas>
        
      </div>
      </div>
      <img class="phone" src="../../static/index/phone.png" alt="" />
      <div class="part2-right">
        <div class="indexTitle1"><span>下载</span>红狮APP</div>
        <div class="contents">
          多功能一站式平台，为您提供伦敦金、伦敦银等品种的开户、交易、出入金、产品报价、行情资讯、财经新闻、专家解盘、24h客服团队等服务，让您不惧时间和空间限制，随时随地使用手机进行交易。
        </div>
        <div class="right-bott">
          <div>
            <img src="../../static/appDownload/Desktop.png" alt="" />
            <span>顶尖技术团队倾力打造</span>
          </div>
          <div>
            <img src="../../static/appDownload/Update.png" alt="" />
            <span>2000+日夜精心打磨APP细节</span>
          </div>
          <div>
            <img src="../../static/appDownload/User Group.png" alt="" />
            <span>200+万用户使用</span>
          </div>
          <div>
            <img src="../../static/appDownload/Earth.png" alt="" />
            <span>权威平台认可</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generateQRCode } from "../../utils/tools";
import { getChannelInfo, getConfigurationValue } from "@/apis/common";

import eventBusMitter from '../../utils/eventbus'
import { getActiveDomain } from '../../utils/IMEI'

export default {
  name: "Appdownload",
  metaInfo: {
    title: '红狮金业APP,现货黄金白银投资专业软件,伦敦金伦敦银靠谱平台,黄金交易红狮启富APP',
    meta: [
      { name: 'keywords', content: '红狮金业,红狮启富,黄金交易平台,贵金属交易软件,贵金属投资APP,贵金属平台,现货黄金开户,现货白银,正规靠谱平台' },
      { name: 'description', content: '红狮金业APP是一款稳定安全的交易软件,专注于为客户提供24小时全球金融产品在线交易,包括现货黄金、现货白银、贵金属等产品的开户、投资交易服务。' }
    ]
  },

     data() {
      return{
        screenWidth:null,
        appName:'红狮乐富',
        showAndroid: true,
      }
    },
    created(){
      eventBusMitter.emit('eventtab', { key: false })

    const Rhref = window.location.host;

      if (Rhref.indexOf('hspluspro') > -1) {
        this.appName = '乐富智享'
      }
      if(Rhref.indexOf('rlctop') > -1){
        this.showAndroid = false
      }
      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
       const channel = sessionStorage.getItem('channel');

    this.getAndroidUrl(channel);
    this.getIosUrl()
    if (this.$route.query.showTop) {
      setTimeout(() => {
        this.scrollToTarget()

      }, 200);
    }
  },
  mounted() {
    const Rhref = window.location.host;

    const { origin } = window.location;
    const channel = this.appName == '乐富智享' ? '9947' : sessionStorage.getItem('channel');
    if (Rhref.indexOf('rlchltd') > -1) {
      var url = 'https://gdown.baidu.com/appcenter/pkg/upload/5e8443261199eb26beca3d0ae105ccaa'

    } else {
      var url = origin + '/subject/download?channel=' + channel

    }
    const icon = require('../../static/index/hongshi.jpg')
    generateQRCode(url, this.$refs.qrcodeCanvas, icon)
    //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })()
    };
  },
  methods: {
    //获取Android下载链接
    async getAndroidUrl(code) {
      const Rhref = window.location.host;

      if (Rhref.indexOf('rlchltd') > -1) {
        this.androidUrl = 'https://gdown.baidu.com/appcenter/pkg/upload/5e8443261199eb26beca3d0ae105ccaa'
      } else {
        const res = await getChannelInfo(code)
        const { downloadUrl } = res;
        this.APKurl = downloadUrl || '';
        const { origin } = window.location;
        const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
        if (absoluteURLRegex.test(downloadUrl)) {
          this.androidUrl = downloadUrl
        } else {
          this.androidUrl = origin + '/' + downloadUrl
        }
      }

    },
    //获取ios下载链接
    async getIosUrl() {
      const res = await getConfigurationValue({ key: 'H5URLBeforeA ' })
      if (res) {
        this.iosUrl = await getActiveDomain(res)
      }
    }, 
    iosDownload() {
      // window.location.href = 'https://apps.apple.com/cn/app/id1598072476';
      window.location.href = this.iosUrl;
    },
    androidDownload() {
      window.location.href = this.androidUrl;
    },
    // 点击跳转到指定位置
    scrollToTarget() {
      const targetElements = this.$refs.targetElement;
      const targetPosition = targetElements.offsetTop;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    },
  },
  watch: {
    screenWidth(n) {
      if (n <= 500) {
        this.$router.push({
          name: "Appdownloadwap",
        });
      }
    },

  },
}
</script>

<style lang="less" scoped>
.Appdownload {
  width: 100%;
  margin: 0 auto;
  text-align: center;

  .bigImg {
    width: 100%;
    height: 810px;
    background: url('../../static/appDownload/topbg.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding-top: 163px;
    position: relative;
    text-align: left;

    .top-left {
      display: flex;
      flex-direction: column;
      width: 1320px;
      margin: 0 auto;

      // align-items: center;
      .top-title {
        color: #fff;
        font-size: 80px;
        font-weight: 700;
        line-height: 106px;
        margin: 34px 0 26px 0;
      }

      .top-img {
        width: 139px;
        height: 38px;
      }

      .top-imgs {
        margin: 66px 0 110px 0;
        width: 198px;
        height: 56px;
        cursor: pointer;
      }

      .top-titles {
        color: #fff;
        font-size: 26px;

        line-height: 34px;
      }
    }

    .top-flex {
      display: flex;
      align-items: center;
    }

    .top-line {
      width: 1px;
      height: 60px;
      margin: 0 32px;
      background: #fff;
    }

    .top-bottoms {
      display: flex;
      align-items: center;

      div {
        display: flex;
        // align-items: center;
        flex-direction: column;
        color: #fff;
        font-size: 16px;
        line-height: 26px;
        margin-left: 12px;
      }
    }

    .codeBox {
      width: 140px;
      height: auto;
      position: absolute;
      right: 450px;
      bottom: 40px;

      img {
        width: 100%;
        height: auto;
      }

      .canvasCode {
        width: 140px !important;
        height: 140px !important;
      }

      p {
        margin: 0;
        background: #e1251a;
        box-sizing: border-box;
        padding: 10px 0;
        color: #fff;
        margin-top: -4px;
      }
    }
  }

  .iconBox {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 80px 20px;

    // background: url('../../static/appDownload/gnBanner.png') no-repeat;
    // background-size: cover;
    .title {
      span {
        color: #FA2314;
      }

      font-size: 46px;
      line-height: 61px;
      color: #0F0F11;
      font-weight: 700;
    }

    .titles {
      font-size: 18px;
      line-height: 24px;
      color: #0F0F11;
      margin: 18px 0 48px 0;
    }

    .ibsBox {
      width: 1130px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;
      position: relative;

      .phone {
        position: absolute;
        left: 50%;
        bottom: -6%;
      }

      .phone1 {
        position: absolute;
        left: 37%;
        bottom: -7%;

        z-index: 10;
      }

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 192px;
        height: 100px;
        background: #fff;

      }

      .icon1 {
        position: absolute;
        top: 65px;
        left: 40px;
        z-index: 10;
      }

      .icon3 {
        position: absolute;
        top: 200px;
        left: -10%;
        z-index: 10;
      }

      .icon2 {
        position: absolute;
        top: 325px;
        left: 96px;
        z-index: 10;
      }

      .icon4 {
        position: absolute;
        top: 65px;
        right: 40px;
        z-index: 10;
      }

      .icon5 {
        position: absolute;
        top: 200px;
        right: -10%;
        z-index: 10;
      }

      .icon6 {
        position: absolute;
        top: 72%;
        right: 96px;
        z-index: 10;
      }

      .icon-img {
        width: 60px;
        height: 60px;
        margin-right: 10px;
      }

      .ixon-imgs {
        width: 72px;
        height: 48px;
      }


    }
  }

  .indexTitle1 {
    font-size: 46px;
    font-weight: 700;
    line-height: 61px;
    text-align: left;
    color: #121212;

    span {
      color: #e1352a;
    }
  }

  .part2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 80px 0;
    background: url('../../static/appDownload/parttop.png') no-repeat;
    mix-blend-mode: multiply;
    /* 使用multiply混合模式 */
    background-color: black;
    /* 叠加的颜色 */
    color: #fff;
    background-size: 100% 100%;
    width: 100%;

    .part2-left {
      margin-left: 15%;

      font-size: 16px;
      line-height: 30px;
      text-align: left;

      img {
        cursor: pointer;
      }
    }

    .ios {
      margin: 18px 0 30px 0;
    }

    .part2-left,
    .part2-right {
      display: flex;
      flex-direction: column;
    }

    .part2-right {
      margin-right: 15%;

      .indexTitle1 {
        color: #fff;
      }
    }

    .download {
      width: 180px;
      height: 54px;
    }

    .phone {
      width: 389px;
      height: 620px;
    }

    .contents {
      margin: 18px 0 32px 0;
      width: 583px;
      height: 90px;
      font-size: 18px;
      line-height: 30px;
      text-align: left;
    }

    .right-bott {
      div {
        display: flex;
        align-items: center;
        margin-bottom: 31px;

        img {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }
      }
    }
  }
}

// -------------------------小屏幕适配-------------------
@media screen and (min-width: 1264px) and (max-width: 1724px) {
  .Appdownload {
    .bigImg {
      .top-left {
        width: 1100px;
        margin: 0 0 0 150px;

        .top-title {
          font-size: 60px;
        }
      }
    }

    .iconBox {
      .ibsBox {
        width: 948px;
      }
    }

    .part2 {
      .contents {
        width: 383px;
        height: 120px;
      }

      .phone {
        width: 283px;
        margin: 0 30px;
      }
    }
  }
}
</style>